import React from "react";
import { deleteAccount } from "../../apis/Auth.Api";
import { FaTimesCircle } from "react-icons/fa";
import PopUp from "../../components/PopUp";
import { RectBtn } from "../../components/General";
import { useSelector } from "react-redux";
import { selectUserData } from "../../features/store";
import { useSnackbar } from "notistack";

const DeleteAccountPopUp = ({ openDelete, setOpenDelete, selectedUser, setSelectedUser, apiRef }) => {
    const { enqueueSnackbar } = useSnackbar();
    const userData = useSelector(selectUserData);
    async function confirmDeleteAccount() {
        let r = await deleteAccount({ user_id: selectedUser.userId });
        if (!r.data.indicator) {
            enqueueSnackbar(r.data.message, { variant: "error" });
            return;
        }
        enqueueSnackbar(r.data.message, { variant: "success" });
        apiRef.current.updateRows([{ id: selectedUser.id, _action: "delete" }]);
        setOpenDelete(false);
        setSelectedUser({});
    }
    return (
        <PopUp width={60} height={45} switchOn={openDelete}>
            <div className="pop-up-content-wrapper">
                <div className="pop-up-row">
                    <h4>Confirmation</h4>
                    <FaTimesCircle
                        className="pop-up-close-btn"
                        onClick={() => {
                            setOpenDelete(false);
                        }}
                    />
                </div>
                <div className="pop-up-division-line"></div>
                <div className="pop-up-body">
                    <div className="confirmation-wrapper">
                        <h4> Delete Account? </h4>
                        <p>
                            By confirming, the account
                            <strong>{" " + selectedUser.userId + " "}</strong> will be deleted. This action cannot be
                            restored.
                        </p>
                        <div className="btn-wrapper">
                            <RectBtn warning={true} onClick={confirmDeleteAccount}>
                                <p>Confirm</p>
                            </RectBtn>
                        </div>
                    </div>
                </div>
            </div>
        </PopUp>
    );
};

export default DeleteAccountPopUp;
